// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e76c8ed9","455":"1c02fc08","977":"6ffc8f9e"}[chunkId] + ".chunk.js";
};